import styled from 'styled-components';

export const StRating = styled.span`
    position: relative;
	display: inline-flex;
	flex-direction: column;
    flex-shrink: 0;
    margin: ${p => p.margin ? p.margin : ''};
`;

export const StRatingRow = styled.span`
    font-size: 0;
	display: flex;
	flex-wrap: nowrap;
    overflow: hidden;
    ${p => p.active && `
        position: absolute;
    `};
    > img{
        vertical-align: top;
	    margin-right: 1px;
    }
`;